import "./AboutHighlights.scss";
import React from 'react';

const AboutHighlights = () => {
  return (
    <section className="aboutSection">
      <div className="container">
        <div className="sectionHead">
          <h2 className="sectionTitle">우리가 하는 일</h2>
          <p className="sectionDesc">
            '홍보'가 목표이지만, 방식은 다양해요. 정보/경험/소통을 하나로 묶습니다.
          </p>
        </div>

        <div className="cards">
          <div className="card">
            <div className="cardTitle">캠퍼스 투어·공식 행사 의전</div>
            <div className="cardDesc">GIST 캠퍼스 투어 운영, 내·외빈 대상 의전 행사 지원, 대외협력팀·입학팀·학생팀 주관 공식 행사 참여</div>
          </div>

          <div className="card">
            <div className="cardTitle">입시 홍보·신입생 안내</div>
            <div className="cardDesc">예비 지스티안을 위한 입시 홍보 콘텐츠 제작 및 안내, 신입생 대상 정보 제공 및 소통</div>
          </div>

          <div className="card">
            <div className="cardTitle">온·오프라인 소통 활동</div>
            <div className="cardDesc">중·고등학생과 GIST 재학생 대상 온·오프라인 콘텐츠 기획, SNS, 카드뉴스, 영상 등 미디어 활동</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHighlights;